import React from 'react';
import {StyledDescription} from "../Description/styled";
import {Button, Typography} from "antd";
import {Container} from "@mui/material";
import { Badge, Card, Space } from 'antd';
const { Title } = Typography;
const { Paragraph, Text } = Typography;


const ZakazHoba = () => {
    return (
        <Container  maxWidth="xl">
            <p>
                <Title style={{color: "white", textAlign: "center"}} italic color={"white"} level={3}>Как заказать хобу (туристическую сидушку) со своим принтом?</Title>

            </p>

            <StyledDescription>
                <Title style={{color: "white", textAlign: "center"}} italic color={"white"} level={4}>Перед заказом нужно понять:</Title>
                <Badge.Ribbon text="1 этап">
                    <Card
                        title={<Button style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{"КАКАЯ ТОЛЩИНА?"}</Button>} bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "left", color: "white"}}>
                        Какой толщины должна быть хоба. В базовом варианте мы выпускаем три толщины 10мм, 15мм и 20мм. Этот материал у нас как правило есть на складе и его не нужно дополнительно закупать. Если вам нужна особенная толщина, то мы можем сделать ее практически любой в диапазоне от 2 до 40мм  по дополнительному согласованию
                    </Card>
                </Badge.Ribbon>
                <Badge.Ribbon text="2 этап">
                    <Card
                        title={<Button style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{"КАКОЙ РАЗМЕР?"}</Button>} bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "left", color: "white", marginTop:"5px"}}>
                        Какой толщины должна быть хоба.  Мы предлагаем наш оптимальный размер сидушки 24х34см. Если вам нужен другой размер, например для детей, то напишите нам и мы обязательно что-нибудь придумаем
                    </Card>
                </Badge.Ribbon>

                <Badge.Ribbon text="3 этап">
                    <Card
                        title={<Button style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{"КАКОЙ ПРИНТ?"}</Button>} bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "left", color: "white", marginTop:"5px"}}>

                        Какой должен быть принт? Или вы выберите наш дизайн и добавите свой логотип или предоставите свой. Можете на словах нам объяснить, что вы хотите и мы постараемся сделать макет за вас. Требования к файлам макетов принтов описаны ниже.                    </Card>
                </Badge.Ribbon>

                <Badge.Ribbon text="4 этап">
                    <Card
                        title={<Button style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{"КАКИЕ ОСОБАННОСТИ?"}</Button>} bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "left", color: "white", marginTop:"5px"}}>
                        Например, если вам нужны светоотражающие элементы, или ткань, которая светится в УФ-лучах или застежка-фастекс определенного цвета или определенный цвет резинки или какая-то особанная упаковка... об этом тоже лучше подумать заранее
                    </Card>
                </Badge.Ribbon>
                <Badge.Ribbon text="5 этап">
                    <Card
                        title={<Button style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{"КАКОЙ ОБЪЕМ И ЦЕНА?"}</Button>} bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "left", color: "white", marginTop:"5px"}}>
                        По цене все будет зависеть от того, какая нужна хоба. Но одно можем сказать точно - ОН БУДЕТ ДЕШЕВЛЕ, чем аналогичный на маркетплейте, но не так быстро. По количеству... Минимальный заказ у нас - это 8 одинаковых сидушек (с одинаковым принтом). Тут дело такое: Если у вас заказ на 32 и более сидушек, то мы в ближайший понедельник запустим вашу партию в печать, если вам нужно меньше тридцати двух, то придется подождать пока мы вас совместим с другим заказом или с нашей плановой печатью, но обо всем этом мы вам скажем по телефону.
                    </Card>
                </Badge.Ribbon>

                <Badge.Ribbon text="6 этап" color={"red"}>
                    <Card
                        title={<Button style={{backgroundColor: "#382b2f"}} color="default" size={"large"}
                                       variant="solid" block>{"СВЯЗАТЬСЯ С НАМИ И ВСЕ СОГЛАСОВАТЬ"}</Button>}
                        bordered={false}
                        style={{backgroundColor: "#382b2f", textAlign: "left", color: "white", marginTop: "5px"}}>
                        Мы подскажем, если что-то непонятно, поможем сделать макет, расчитаем стоимость и сроки
                        изготовления и доставки. После всех согласований, составляем договор, выставляем счет и после
                        100% предоплаты изготавливаем сидушки в установленный срок!
                        <p className={"unpadding"}>Наш телефон (Анна): <a href={"tel:+79250385050"}>+7 925
                            0385050</a></p>
                        <p className={"unpadding"}>Наш Telegram (Анна): <a href={"https://t.me/Go_bananas_ru"}>@Go_bananas_ru</a></p>
                        <p className={"unpadding"}>Наш WHATSAPP (Анна): <a href={"https://api.whatsapp.com/send/?phone=79032092209&text&type=phone_number&app_absent=0"}>GoBananas</a></p>
                        <p className={"unpadding"}> Email: <a href={"mailto:info@go-bananas.ru"}>info@go-bananas.ru</a>
                        </p>
                    </Card>
                </Badge.Ribbon>


            </StyledDescription>
            {/*<Title style={{color: "white", textAlign: "center"}} italic color={"white"} level={3}>Что мы можем?</Title>*/}
            {/*<StyledDescription>*/}
            {/*    <Paragraph ellipsis={false} style={{color: "white"} }>*/}
            {/*        Пока только баффы и туристические сидушки. Мы рисуем, генерируем и всячески добываем принты на наши изделия. Их очень много. Если вам ничего не подошло и вы хотите что-то свое или с логотипом вашего сообщества, компании или фотографией - мы это с легкостью можем сделать. Любой бафф или хобу нежного размера и с нужным принтом! Просто напишите нам и мы договоримся))*/}
            {/*    </Paragraph>*/}
            {/*</StyledDescription>*/}

        </Container>
    );
};


export default ZakazHoba;